import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  LucideSearch, LucidePlus, LucideBell, LucideSettings, LucideHome,
  LucideLayoutDashboard, LucideList, LucideCalendar, LucideClock,
  LucideInbox, LucideStar, LucideUsers, LucideFilter, LucideMoreHorizontal,
  LucidePaperclip, LucideLink, LucideSend, LucideArrowUp, LucideArrowDown,
  LucideArrowRight, LucideChevronDown, LucideChevronRight, LucideChevronLeft,
  LucideX, LucideFlag, LucideBug, LucideUser, LucideLogOut, LucideZap,
  LucideCheck, LucideCheckCircle, LucideLayers, LucideGitBranch, LucideTrash2,
  LucideDownload, LucideUpload, LucideArchive, LucideHelpCircle, LucideSliders,
  LucideBookmark, LucideEye, LucideEyeOff, LucideMessageSquare, LucidePanelLeft,
  LucideMail, LucidePencil, LucideUserPlus, LucidePower, LucideShield,
  LucideLock, LucideRotateCcw, LucideCamera, LucideGlobe, LucideFolder,
  LucideMinus, LucideBriefcase, LucideCompass, LucideFile, LucideReply,
  LucideArrowUpDown, LucideListPlus, LucideCornerDownRight, LucideRocket,
  provideLucideIcons,
} from '@lucide/angular';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { responseInterceptor } from './core/interceptors/response.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([responseInterceptor, authInterceptor])),
    provideLucideIcons(
      LucideSearch, LucidePlus, LucideBell, LucideSettings, LucideHome,
      LucideLayoutDashboard, LucideList, LucideCalendar, LucideClock,
      LucideInbox, LucideStar, LucideUsers, LucideFilter, LucideMoreHorizontal,
      LucidePaperclip, LucideLink, LucideSend, LucideArrowUp, LucideArrowDown,
      LucideArrowRight, LucideChevronDown, LucideChevronRight, LucideChevronLeft,
      LucideX, LucideFlag, LucideBug, LucideUser, LucideLogOut, LucideZap,
      LucideCheck, LucideCheckCircle, LucideLayers, LucideGitBranch, LucideTrash2,
      LucideDownload, LucideUpload, LucideArchive, LucideHelpCircle, LucideSliders,
      LucideBookmark, LucideEye, LucideEyeOff, LucideMessageSquare, LucidePanelLeft,
      LucideMail, LucidePencil, LucideUserPlus, LucidePower, LucideShield,
      LucideLock, LucideRotateCcw, LucideCamera, LucideGlobe, LucideFolder,
      LucideMinus, LucideBriefcase, LucideCompass, LucideFile, LucideReply,
      LucideArrowUpDown, LucideListPlus, LucideCornerDownRight, LucideRocket,
    ),
  ],
};
